import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z, ZodType } from 'zod';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import es from '@/config/languages/es';

export const useCustomForm = <T extends ZodType>(
  formSchema: (t: (textId: keyof typeof es) => string) => T,
  defaultValues: z.infer<T>,
) => {
  const { getTextIdTranslation } = useTranslation();

  return useForm<z.infer<ReturnType<typeof formSchema>>>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: zodResolver(formSchema(getTextIdTranslation)),
    defaultValues,
  });
};
